import * as React from 'react';
import { NoRangesConfigured } from '@grandvisionhq/fun-products';
import { CLPrescriptionSelector } from './CLPrescriptionSelector.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';

/** @deprecated */ const CLPrescriptionSelectorContainer = ({ prescriptionAttributesSet  })=>{
    const { state , triggerToastMessage  } = useCLEcommContext();
    // Get the UI validation state for the prescription columns and checkboxes
    const { columns: { showError: showColumnsError  } , columnCheckboxes: { showError: showCheckboxesError  } , invalidSubmissionsCount ,  } = state.configurator;
    React.useEffect(()=>{
        if (showColumnsError || showCheckboxesError) {
            triggerToastMessage('prescription-form-error');
        }
    }, [
        showColumnsError,
        showCheckboxesError,
        invalidSubmissionsCount
    ]);
    if (!prescriptionAttributesSet || prescriptionAttributesSet.length === 0) {
        return /*#__PURE__*/ React.createElement(NoRangesConfigured, null);
    }
    return /*#__PURE__*/ React.createElement(CLPrescriptionSelector, {
        prescriptionAttributesSet: prescriptionAttributesSet
    });
};

export { CLPrescriptionSelectorContainer };
//# sourceMappingURL=CLPrescriptionSelectorContainer.js.map
